import { makeStyles, MenuItem } from '@material-ui/core';
import { FC } from 'react';
import CButton from 'src/component/Button';
import { DefaultSelect } from 'src/component/Select';

const useStyle = makeStyles({
  inputRow: {
    '& > *:nth-child(1)': {
      flex: 'auto'
    },
    alignItems: 'center',
    display: 'flex',
    width: '100%'
  }
});

interface ModalSelectGroupProps {
  buttonText?: string;
  onButtonClick?: () => void;
  onSelect: (value: string) => void;
  options: string[];
  value: string;
}

const ModalSelectGroup: FC<ModalSelectGroupProps> = ({
  buttonText,
  onButtonClick,
  onSelect,
  options,
  value
}) => {
  const classes = useStyle();

  return (
    <div className={classes.inputRow}>
      <DefaultSelect defaultValue={options[0]} onSelect={onSelect} value={value}>
        {options.map((option) => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </DefaultSelect>

      {buttonText && onButtonClick && (
        <CButton
          htmlType="button"
          onClick={onButtonClick}
          type="primary"
          xstyle={{ borderRadius: '12px' }}
        >
          {buttonText}
        </CButton>
      )}
    </div>
  );
};

export default ModalSelectGroup;
